// routes
import { PATH_DASHBOARD } from "../../routes/paths";
// components
import SvgIconStyle from "../../components/SvgIconStyle";

import {
  DASHBOARD,
  STORE_DASHBOARD,
  ORDERS_MANAGEMENT,
  ORDERS_DELIVERY,
  ORDERS_SUB_EXPORT_DATA,
  MASTER_CATALOG_BRAND,
  MASTER_CATALOG_PRODUCT,
  MASTER_CATALOG_COUPONS,
  MASTER_CATALOG_DISPLAY_CATEGORY,
  BRANCH_CATALOG_PRODUCT,
  BRANCH_CATALOG_DISPLAY_COTEGORY,
  PROMOTIONS_MANAGEMENT,
  HOME_TEMPLATE_MANAGEMENT,
  REPORT,
  PERMISSION,
} from '@root/jnzAuthWrapper/permission-keys';

// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle
    src={`/static/icons/navbar/${name}.svg`}
    sx={{ width: "100%", height: "100%" }}
  />
);

const ICONS = {
  user: getIcon("ic_user"),
  ecommerce: getIcon("ic_ecommerce"),
  analytics: getIcon("ic_analytics"),
  dashboard: getIcon("ic_new_dashboard"),
  orders: getIcon("ic_new_orders"),
  master_catalog: getIcon("ic_new_master_catalog"),
  branch_catalog: getIcon("ic_new_branch_catalog"),
  promotions: getIcon("ic_new_promotions"),
  home_management: getIcon("ic_new_home_management"),
  flash_sale: getIcon("ic_new_flash_sale")
};


const sidebarConfig = [
  // ----------------------------------------------------------------------
  // GENERAL
  // ----------------------------------------------------------------------
  {
    // subheader: "general",
    items: [
      {
        title: "Dashboard",
        path: PATH_DASHBOARD.dashboard.root,
        icon: ICONS.dashboard,
        permission_key: DASHBOARD,
        children: [
          { title: "Dashboard", path: PATH_DASHBOARD.dashboard.dashboard || '', permission_key: DASHBOARD },
          // { title: "Store Dashboard", path: PATH_DASHBOARD.dashboard.storeDashboard || '',permission_key:STORE_DASHBOARD},
        ],
      },
      {
        title: "Report",
        path: PATH_DASHBOARD.report.root,
        icon: ICONS.analytics,
        permission_key: REPORT,
        children: [
          { title: "Report", path: PATH_DASHBOARD?.report?.pageCategories || '', permission_key: REPORT },
        ],
      },
      // {
      //   title: "Report",
      //   path: PATH_DASHBOARD.report.pageCategories,
      //   icon: ICONS.analytics,
      //   permission_key: REPORT,
      // },
      {
        title: "Orders",
        path: PATH_DASHBOARD.orders.root,
        icon: ICONS.orders,
        permission_key: ORDERS_MANAGEMENT,
        children: [
          { title: "Order Management", path: PATH_DASHBOARD?.orders?.pageOrders || '', permission_key: ORDERS_MANAGEMENT },
          // { title: "Delivery Management", path: PATH_DASHBOARD?.orders?.delivery || '',permission_key:ORDERS_DELIVERY },
        ],
      },
      {
        title: "Master Catalog",
        path: PATH_DASHBOARD.masterCatalog.root,
        icon: ICONS.master_catalog,
        permission_key: MASTER_CATALOG_PRODUCT,
        children: [
          { title: "Master Products", path: PATH_DASHBOARD?.masterCatalog?.pageProducts || '', permission_key: MASTER_CATALOG_PRODUCT },
          { title: "Master Categories", path: PATH_DASHBOARD?.masterCatalog?.pageDisplayCategories || '', permission_key: MASTER_CATALOG_DISPLAY_CATEGORY },
          // { title: "Internal Categories", path: PATH_DASHBOARD?.masterCatalog?.pageInternalCategories || '',permission_key:'' },
          { title: "Master Brands", path: PATH_DASHBOARD?.masterCatalog?.pageBrandsSuppliers || '', permission_key: MASTER_CATALOG_BRAND },
          { title: "Master Coupons", path: PATH_DASHBOARD?.masterCatalog?.pageCoupons || '', permission_key: MASTER_CATALOG_COUPONS },
        ],
      },
      {
        title: "Branch Catalog",
        path: PATH_DASHBOARD.branchCatalog.root,
        icon: ICONS.branch_catalog,
        permission_key: '',
        children: [
          { title: "Map Display Categories and Stores", path: PATH_DASHBOARD?.branchCatalog?.pageDisplayCategories || '', permission_key: BRANCH_CATALOG_PRODUCT },
          { title: "Map Products and Stores", path: PATH_DASHBOARD?.branchCatalog?.pageProducts || '', permission_key: BRANCH_CATALOG_DISPLAY_COTEGORY },
        ],
      },
      // {
      //   title: "Catalog",
      //   path: PATH_DASHBOARD.general.catalog,
      //   icon: ICONS.ecommerce,
      //   permission_key:'',
      //   children: [
      //     { title: "Display Categories", path: PATH_DASHBOARD?.catalog?.pageCategories || '',permission_key:''  },
      //   ],
      // },
      {
        title: "Promotions",
        path: PATH_DASHBOARD.promotions.root,
        icon: ICONS.promotions,
        permission_key: PROMOTIONS_MANAGEMENT,
        children: [
          { title: "Promotions Display", path: PATH_DASHBOARD?.promotions?.pageCategories || '', permission_key: PROMOTIONS_MANAGEMENT },
        ],
      },
      {
        title: "Home Management",
        path: PATH_DASHBOARD.homeManagement.pageHomeTemplate,
        icon: ICONS.home_management,
        permission_key: HOME_TEMPLATE_MANAGEMENT,
      },
      // {
      //   title: "Company Management",
      //   path: PATH_DASHBOARD.general.companyManagement,
      //   icon: ICONS.ecommerce,
      //   children: [
      //     { title: "Display Company", path: PATH_DASHBOARD?.companyManagement?.pageCategories || '',permission_key:''  },
      //   ],
      // },
      // {
      //   title: "Shop Management",
      //   path: PATH_DASHBOARD.general.shopManagement,
      //   icon: ICONS.ecommerce,
      //   children: [
      //     { title: "Display Shop", path: PATH_DASHBOARD?.shopManagement?.pageCategories || '',permission_key:''  },
      //   ],
      // },
      // {
      //   title: "Report",
      //   path: PATH_DASHBOARD.report.root,
      //   icon: ICONS.analytics,
      //   permission_key: REPORT,
      //   children: [
      //     { title: "Display Shop", path: PATH_DASHBOARD?.report?.pageCategories || '', permission_key: REPORT },
      //   ],
      // },
      // {
      //   title: "Two",
      //   path: PATH_DASHBOARD.general.pageTwo,
      //   icon: ICONS.ecommerce,
      // },
      // {
      //   title: "Three",
      //   path: PATH_DASHBOARD.general.pageThree,
      //   icon: ICONS.analytics,
      // },
    ],
  },
  // ----------------------------------------------------------------------
  // MANAGEMENT
  // ----------------------------------------------------------------------
  // {
  //   subheader: "management",
  //   items: [
  //     {
  //       title: "user",
  //       path: PATH_DASHBOARD.app.root,
  //       icon: ICONS.user,
  //       permission_key: '',
  //       children: [
  //         { title: "Four", path: PATH_DASHBOARD.app.pageFour, permission_key: '' },
  //         { title: "Five", path: PATH_DASHBOARD.app.pageFive, permission_key: '' },
  //         { title: "Six", path: PATH_DASHBOARD.app.pageSix, permission_key: '' },
  //       ],
  //     },
  //   ],
  // },
  // ----------------------------------------------------------------------
];

export default sidebarConfig;
